import styled from 'styled-components';

import { colorPalette, colorTokens, variables } from '../../components/variables';

export const BannerContainer = styled.div`
  background-color: ${colorTokens.background.light};
  display: flex;
  align-items: center;
  padding: 0 10px;
  height: 38px;
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 100;
  border-bottom: 1px solid ${colorPalette.neutralVariant90};

  ${variables.mediaQuery.greaterThan('desktop')`
    margin-left: -32px;
    margin-right: -24px;
    padding-left: 42px;
    padding-right: 34px;
  `}

  ${variables.mediaQuery.lessThan('desktop')`
    top: 62px;
    margin: 0 -16px
  `}
`;
